var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { SerializableMember, SerializableObject } from '@openhps/core';
let Slant = class Slant {
    constructor() {
        this.direction = SlantDirection.DOWN;
    }
};
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], Slant.prototype, "direction", void 0);
Slant = __decorate([
    SerializableObject()
], Slant);
export { Slant };
export var SlantDirection;
(function (SlantDirection) {
    SlantDirection[SlantDirection["DOWN"] = 0] = "DOWN";
})(SlantDirection || (SlantDirection = {}));
//# sourceMappingURL=Slant.js.map